import { render, staticRenderFns } from "./LoginRecovery.vue?vue&type=template&id=8af27a8a&scoped=true&"
import script from "./LoginRecovery.vue?vue&type=script&lang=js&"
export * from "./LoginRecovery.vue?vue&type=script&lang=js&"
import style0 from "./LoginRecovery.vue?vue&type=style&index=0&id=8af27a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af27a8a",
  null
  
)

export default component.exports